import { render } from "./DataSikejam.vue?vue&type=template&id=4bacc977"
import script from "./DataSikejam.vue?vue&type=script&lang=js"
export * from "./DataSikejam.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__